import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientRepresentativeSettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../helpers';

export const useClientRepresentativeSettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useClientRepresentativeSettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (id: string, currentStepName: OnboardingProcessStepNameType) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id,
          input,
        },
      });
      return res.data?.clientRepresentativeSettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.clientRepresentativeSettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveSettings,
  };
};
